/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Command } from '../../../model/Command';
import { BaseController } from '../../BaseController';
import { SiteAttachmentViewController } from './SiteAttachmentView';

class SiteViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, siteService, domainService, waitSpinnerService, $q, $state, $stateParams, $log,
        notificationService, filterService, siteAttachmentService, dialogService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.siteService = siteService;
        this.domainService = domainService;
        this.filterService = filterService;
        this.siteAttachmentService = siteAttachmentService;
        this.dialogService = dialogService;
        this.$log.debug('Controller \'SiteView\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.formDisabled = false;
        this.domains = [];
        this.commands = [];

        // The updateMode flag can be used to know the context in which this controller is running: creation or update.
        let initPromise;
        let domainPromise;
        if (this.$stateParams.hasOwnProperty('id')) {
            this.updateMode = true;
            this.title = 'ui.site.update';
            initPromise = this.siteService.getEntity(this.$stateParams.id);
            domainPromise = [];
        } else {
            this.updateMode = false;
            this.title = 'ui.site.create';
            initPromise = {};
            domainPromise = this.domainService.findEntities({
                params: this.filterService.buildSortingParam({sort: 'name'})
            });
        }

        this.handleRestServiceCall(this.$q.all({
            entity: initPromise,
            domains: domainPromise
        }), data => {
            this.pristineEntity = data.entity;
            this.domains = data.domains;
            this.reset();
            this.initCommands();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        if (this.updateMode) {
            this.commands.push(
                Command.handlerCommand('ui.site.addattachments', 'images/svg/attachment.svg',
                    () => this.showAttachmentViewDialog())
            );
        }
    }

    /**
     * Shows a dialog containing the form to add attachments. When the dialog is closed, the view is refreshed.
     *
     * @return {Promise} A promise of the action.
     */
    showAttachmentViewDialog() {
        this.dialogService.showDialog(SiteAttachmentViewController,
            'organization/component/siteattachment-view.html', { siteId: this.site.id }
        ).then(confirmed => {
            if (confirmed) {
                this.$onInit();
            }
        });
    }

    /**
     * Shows a confirmation dialog before deleting an attachment. If the dialog is confirmed, the attachment is deleted.
     *
     * @param {integer} id ID of the attachment.
     * @return {Promise} A promise containing the confirmation result.
     */
    showAttachmentDeleteConfirmationDialog(id) {
        return this.dialogService.showConfirmationDialogWithMessage('ui.attachment.deleteconfirmation').then(
            confirmed => {
                if (confirmed) {
                    this.deleteAttachment(id);
                }
                return confirmed;
            }
        );
    }

    /**
     * Deletes immediately an attachment without confirmation, and reloads the site.
     *
     * @param {integer} id ID of the attachment.
     */
    deleteAttachment(id) {
        return this.handleRestServiceCall(this.siteAttachmentService.deleteEntity({siteId: this.site.id, id}), () => {
            this.notificationService.pushMessage('ui.attachment.deleted',
                this.configuration.NOTIFIER_LEVEL_INFO);
            this.$onInit();
        });
    }

    save() {
        this.formDisabled = true;
        let serviceActionPromise;
        if (this.updateMode) {
            serviceActionPromise = this.siteService.updateEntity(this.site);
        } else {
            serviceActionPromise = this.siteService.createEntity(this.site);
        }
        this.handleRestServiceCall(serviceActionPromise, () => {
            const message = 'ui.site.' + (this.updateMode ? 'updated' : 'created');
            this.notificationService.pushMessage(message, this.configuration.NOTIFIER_LEVEL_INFO);
            if (this.updateMode) {
                this.$state.reload();
            } else {
                this.$state.go('gmao.organization.site.list');
            }        }).finally(() => {
            this.formDisabled = false;
        });
    }

    reset() {
        this.site = angular.copy(this.pristineEntity);
    }
}

export const siteViewComponent = {
    template: require('./site-view.html'),
    controller: SiteViewController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/component/SiteView.js